import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    z-index: 3000;
  `,
  content: css`
    max-width: 400px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
